export default __webpack_public_path__ + "static/journal-a5cd3595caa27873c7e960849492196b.png";